import styled from "styled-components";

export const LeaderboardAdContainer = styled.a`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 600px;
    height: 200px;
    object-fit: contain;
  }

  @media screen and (max-width: 641px) {
    img {
      width: 100%;
      height: 100%;
    }
  }
`;
